/**
 * Feature flags that control features exposed to the public faced app (e.g.
 * rooms view page)
 */
const publicFeatureFlags = `
  consentDeclinedSuppression
  disableRoomStickyColumns
  hidePoweredBy
  newPdfViewer
  showAllCollaborators
  smsNotifications
  autoRoomCreation
  federatedAssetEnabled
  releaseControlFlagAssetPicker
  inlineIframeViewer
  releaseControlBuyerCopilot
  buyerCopilotEnabled
  defaultContentDownload


`;

/**
 * Feature flags that control features with limited audience on the logged-in
 * (private) app (e.g. experimental features or not yet publicly available)
 */
const privateFeatureFlags = `
  ${publicFeatureFlags}
  crmInfoSearch
  featureCrmAbstractionMsDynamics
  consentDeclinedSuppression
  disableSort
  disableDealCreation
  disableCompanyCreation
  disableStartConversation
  editCopy
  forceRoomsDealCreation
  allowSkipDeal
  fullTextSearch
  insightsOptimizationV2
  inhouseConsent
  inhouseSigner
  insightsContentWonDeals
  internalRoomsV2
  openAi
  roomBlacklistDomains
  vanityUrlFeature
  enforcedAllowedViewersOnly
  enforcedRequiredPin
  featureFlagSupportMulticurrencySfdc
  releaseControlBuyerCopilot
  releaseControlDsrFolders
  enforcedRequiredEmail
  releaseControlRestrictUserVisibility
  releaseControlPartnerSettings
`;

export const getMeOrgFields = `
  ${privateFeatureFlags}
  id
  activeUsersCount
  address
  allowSupportLogin
  contentIndexingStatus
  convertApiEnabled
  createdAt
  crmIntegrationFeature
  defaultContentDownload
  discoveryReason
  email
  emailSenderConfigurable
  employeeRange
  gongStorageProvider
  languages
  logo
  mutualActionPlans
  name
  tenantType
  pdfViewerLicenseKey
  phone
  primaryUsage
  privacyPolicyLink
  privacyPolicyName
  referenceManagement
  ringCentral
  ringcentralStorageProvider
  sharedLinks
  signablesFeature
  signableTemplates
  isUserHierarchyConfigured
  status
  subscriptionStatus
  totalUsersCount
  vanityUrl
  vendorId
  vendorTenantId
  vendorTenantUrl
  website
  zoomStorageProvider
  orgType
  crmCorporateCurrency
  orgSubscription {
    id
    createdAt
    frequency
    licenses
    licensesSelfServe
    manageUrl
    status
    trialEndDate
    usedLicensesCount
    plan {
      uuid
      name
    }
  }
  vendor {
    analyticsPrefix
    homeUrl
    name
    emailSenderName
    pdfViewerLicenseKey
    privacyPolicyLink
  }
`;

export const settingsOrgFields = `
  id
  actionPlanLabel
  bannerAssetId
  bannerUri
  buyerCopilotEnabled
  colors
  defaultContentDownload
  disableRoomStickyColumns
  disableSort
  domainBlacklist
  domainWhitelist
  faviconUri
  fonts
  geoTargetConsent
  pageDescription
  pageTitle
  privacyPolicyLink
  privacyPolicyName
  scheduleCall
  website
`;

export const primaryOrganizationFields = `
  primaryOrganization{
    id
    name
  }
`;

export const templateSettingsOrgFields = `
  ${settingsOrgFields}
  ${primaryOrganizationFields}
`;

export const partnerSettingsOrgFields = `
  partnerConfiguration {
      primaryOrganizationId
      name
      email
      address
      phone
      website
      pageTitle
      bannerUri
      bannerAssetId
      faviconUri
      logo
      colors
      fonts
      domainWhitelist
      domainBlacklist
      allowSupportLogin
      dataEnrichment
      scheduleCall
      geoTargetConsent
      privacyPolicyLink
      privacyPolicyName
      defaultContentDownload
    }
`;

export const settingsUpdateOrgFields = `
  id
  actionPlanLabel
  bannerAssetId
  bannerUri
  buyerCopilotEnabled
  colors
  consentContactEnrichmentEvents {
    id
    user {
      fullName
    }
    meta
    createdAt
  }
  dataEnrichment
  disableRoomStickyColumns
  disableSort
  domainWhitelist
  faviconUri
  fonts
  geoTargetConsent
  pageDescription
  pageTitle
  privacyPolicyLink
  privacyPolicyName
  scheduleCall
  website
`;

export const updateOrgFields = `
  consentContactEnrichmentEvents {
    id
    user {
      fullName
    }
    meta
    createdAt
  }
`;

export const integrationOrgFields = `
  id
  amountSourceField
  crmIntegration {
    id
    configuration
    createdAt
    deactivated
    providerName
    updatedAt
    version
    logs(limit: 5) {
      createdAt
      results
      source
      status
      transactionId
    }
  }
`;

export const crmIntegrationProviderName = `
  id
  crmIntegration {
    id
    providerName
    integrationType
    deactivated
  }
`;

export const roomOrgFields = `
  ${publicFeatureFlags}
  id
  actionPlanLabel
  buyerCopilotEnabled
  colors
  convertApiEnabled
  fonts
  isCurrentUserMember
  logo
  name
  tenantType
  pageTitle
  pdfViewerLicenseKey
  privacyPolicyLink
  privacyPolicyName
  inhouseConsent
  scheduleCall
  vanityUrl
  vendorTenantId
  tenantId
  vendorTenantUrl
  website
  vendor {
    homeUrl
    name
    pdfViewerLicenseKey
    privacyPolicyLink
  }
`;

export const roomSettingsOrgFields = `
  ${settingsOrgFields}
  ${integrationOrgFields}
`;

export const libraryFilters = `
  libraryFilters
  fullTextSearch
`;

export const integrationBasicFields = `
  crmIntegration {
    id
  }
`;

export const domainBlacklistFields = `
  domainBlacklist
`;

export const integrationOrgConfigFields = `
  id
  crmIntegration {
    id
    configuration
    providerName
    version
    notificationUser {
      id
      fullName
    }
  }
`;

export const integrationOrgConfigDealFields = `
  id
  crmIntegration {
    id
    configuration
    providerName
  }
`;
